import { render } from "./FooterView.vue?vue&type=template&id=72c99ce8&scoped=true"
const script = {}

import "./FooterView.vue?vue&type=style&index=0&id=72c99ce8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c99ce8"]])

export default __exports__